import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import i18n from 'i18n-js';
import * as Yup from 'yup';
import { FormChanges } from 'utils';
import { Formik, Field } from 'formik';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import useStyles from './Activation.styled';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import { vehicleActions } from 'state/modules/vehicles';

import { MaterialSelectField, DateTimePickerField, SwitchField } from 'components/FormFields';

const VehicleActivation = ({ currentVehicle, formRef, displaySuccessModal, onSave }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const effectiveOptions = [
    {
      value: 'immediately',
      label: i18n.t('vehicle.immediately'),
    },
    {
      value: 'date',
      label: i18n.t('vehicle.specific_date_time'),
    },
  ];

  useEffect(() => {
    if (currentVehicle?.id) {
      dispatch(vehicleActions.fetchVehicleById(currentVehicle.id));
    }
  }, []) // eslint-disable-line

  const initialValues = {
    activation: true,
    effectiveOption: 'immediately',
    start_time: '',
  };

  const formSchema = Yup.object().shape({
    activation: Yup.boolean(),
    effectiveOption: Yup.string(),
    start_time: Yup.string(),
  });

  const onSubmit = (values) => {
    if (!values.activation) return displaySuccessModal();

    let payload = {
      status: 'ACTIVE',
    };

    if (values.start_time) payload.start_time = values.start_time;

    dispatch(vehicleActions.changeVehicleStatus(payload));
  };

  return (
    <Box className={classes.container}>
      <Container className="h-100">
        <Grid
          container
          className={classes.container}
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item xs={10}>
            <Formik
              innerRef={formRef}
              initialValues={initialValues}
              validationSchema={formSchema}
              enableReinitialize={true}
              onSubmit={onSubmit}
            >
              {({ handleSubmit, values }) => (
                <form noValidate onSubmit={handleSubmit}>
                  <Grid item xs={12}>
                    <Box display="flex" alignItems="center" justifyContent="space-between">
                      <Typography variant="h6">
                        <Box fontWeight="fontWeightBold" fontSize={14} style={{ height: '100%' }}>
                          {i18n.t('vehicle.vehicle_ativation_title')}
                        </Box>
                      </Typography>
                      <Box mx={3}>
                        <Field name="activation" component={SwitchField} />
                      </Box>
                    </Box>
                    <Box display="flex" alignItems="left" justifyContent="flex-start">
                      <Typography variant="h4">
                        <Box fontSize={12} style={{ height: '100%', maxWidth: '500px' }}>
                          {i18n.t('vehicle.vehicle_ativation_description')}
                        </Box>
                      </Typography>
                    </Box>
                  </Grid>
                  {values.activation && (
                    <Grid item xs={12}>
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="flex-start"
                        justifyContent="flex-start"
                      >
                        <Grid item xs={12} className={classes.mt}>
                          <Field
                            name="effectiveOption"
                            component={MaterialSelectField}
                            options={effectiveOptions?.map((val) => {
                              return {
                                value: val.value,
                                label: val.label,
                              };
                            })}
                            placeholder={'Effective'}
                          />
                        </Grid>
                      </Box>
                      {values.effectiveOption === 'date' && (
                        <Box
                          display="flex"
                          flexDirection="column"
                          alignItems="flex-start"
                          justifyContent="flex-start"
                          mt={2}
                        >
                          <Grid item xs={12} className={classes.mt}>
                            <Field
                              name="start_time"
                              component={DateTimePickerField}
                              label={'Start date and time'}
                              editable={true}
                            />
                          </Grid>
                        </Box>
                      )}
                    </Grid>
                  )}
                  <Grid item xs={12}>
                    {Array.isArray(currentVehicle?.activation_requirements) && (
                      <Typography variant="h6">
                        <Box fontWeight="fontWeightBold" fontSize={14} mt={3}>
                          {i18n.t('vehicle.missing')}
                        </Box>
                      </Typography>
                    )}
                    {Array.isArray(currentVehicle?.activation_requirements) && (
                      <ul className={classes.requiremmentList}>
                        {currentVehicle.activation_requirements.map((requiremment, index) => (
                          <li className={classes.requiremmentItem} key={index}>
                            {requiremment}
                          </li>
                        ))}
                      </ul>
                    )}
                  </Grid>
                  <FormChanges initialValues={initialValues} onSave={onSave} />
                </form>
              )}
            </Formik>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default VehicleActivation;
